export const HORIZONTAL_POSITION_META = {
  A: {
    label: "Mi YO que no pude ser",
    shortLabel: "Karma del clan",
    source: "Mes de nacimiento",
    icon: "🔥",
    description:
      "La tarea heredada que tu clan no resolvió y que hoy puede frenarte si sigues actuando por lealtad ciega."
  },
  B: {
    label: "Mi nuevo YO",
    shortLabel: "Esencia en construcción",
    source: "Día de nacimiento",
    icon: "✨",
    description:
      "La identidad que vienes a desarrollar en esta vida cuando eliges tu propio camino y dejas de pedir permiso."
  },
  C: {
    label: "Mi YO del pasado",
    shortLabel: "Sabiduría ya aprendida",
    source: "Año de nacimiento",
    icon: "🕊️",
    description:
      "La energía que ya dominaste en gran parte y que puede volverse talento o zona segura, según cómo la uses."
  },
  D: {
    label: "Mi máscara del YO",
    shortLabel: "Imagen que proyectas",
    source: "Día + mes + año",
    icon: "🎭",
    description:
      "La personalidad con la que te presentas al mundo: útil para abrir puertas, pero riesgosa si reemplaza a tu esencia."
  }
};

export const HORIZONTAL_NUMEROLOGICA = {
  A: {
    1: {
      title: "Número 1",
      summary:
        "Vienes a romper la lealtad al éxito ajeno y al hijo modelo para construir identidad propia sin orgullo ni control.",
      longText:
        "Tu historia puede empujarte a destacar, ganar admiración o vincularte con personas exitosas para sentir valor. El aprendizaje consiste en independizarte del molde familiar, dejar de medir tu valía por el reconocimiento del clan y usar tu liderazgo sin ego, intolerancia ni dominio.",
      keywords: ["identidad", "liderazgo", "ego", "independencia"]
    },
    2: {
      title: "Número 2",
      summary:
        "Tu herida habla de apego al vínculo familiar y de la dificultad para confiar, separarte y construir paz sin perderte en el otro.",
      longText:
        "Esta energía suele cargar con la misión de mantener unido al clan y por eso teme soltar física o emocionalmente a los suyos. Tu evolución pasa por dejar la manipulación, la hiperadaptación y la desconfianza para construir vínculos equilibrados donde puedas pertenecer sin renunciar a tu individualidad.",
      keywords: ["vínculo", "confianza", "pertenencia", "autonomía"]
    },
    3: {
      title: "Número 3",
      summary:
        "La tarea pendiente es dejar de vivir para agradar y empezar a ser leal a tu propia voz, tu verdad y tus deseos.",
      longText:
        "Aquí suele haber una historia de aprobación, obediencia y brillo puesto al servicio de los demás. El movimiento sano consiste en dejar de hacer felices a todos, escuchar lo que realmente quieres y enfocarte en tu propio escenario para expresarte con autenticidad.",
      keywords: ["autenticidad", "aprobación", "voz", "enfoque"]
    },
    4: {
      title: "Número 4",
      summary:
        "Vienes a romper un modelo familiar rígido, estancado o carente, para construir estabilidad con flexibilidad y bienestar real.",
      longText:
        "Tu herencia puede haberte enseñado a sobrevivir desde el esfuerzo excesivo, el control y el miedo a perder lo construido. El aprendizaje consiste en cambiar la vieja idea de seguridad, equilibrar trabajo con descanso y permitirte una vida con placer, afecto y movimiento.",
      keywords: ["estructura", "escasez", "disciplina", "flexibilidad"]
    },
    5: {
      title: "Número 5",
      summary:
        "La lección es salir del conformismo, la represión y el miedo al cambio para recuperar tu libertad interior.",
      longText:
        "Esta posición suele hablar de historias de sometimiento, prohibición o maltrato que dejaron como huella cobardía y resignación. Tu evolución pasa por cortar cadenas, moverte aun sin certezas y desarrollar templanza para aceptar que la vida cambia y no puede ser controlada.",
      keywords: ["libertad", "cambio", "valentía", "templanza"]
    },
    6: {
      title: "Número 6",
      summary:
        "Tu karma aparece cuando buscas amor sirviendo, sacrificándote o poniéndote al final para no perder el vínculo.",
      longText:
        "Aquí suele existir una deuda con el merecimiento: se ama desde la entrega excesiva y se espera recibir valor a cambio de sostener a todos. El reto es construir amor propio, estabilidad emocional y relaciones donde el cuidado no implique abandono de ti mismo.",
      keywords: ["merecimiento", "amor propio", "servicio", "límites"]
    },
    7: {
      title: "Número 7",
      summary:
        "Vienes a dejar atrás reglas, culpas y expectativas ajenas para construir tu propia filosofía de vida y seguir tus sueños.",
      longText:
        "Esta energía carga con paradigmas rígidos, prohibiciones y la sensación de no ser suficiente para salir del mandato familiar. La salida está en confiar en tu propia visión, desprenderte de la culpa y elegir una vida guiada por tu verdad, aunque el clan no la apruebe.",
      keywords: ["verdad", "culpa", "creencias", "proyecto propio"]
    },
    8: {
      title: "Número 8",
      summary:
        "Tu tarea es dejar de vivir bajo la historia de poder, carencia o seguridad del clan para crear tu propia abundancia.",
      longText:
        "Este número suele heredar miedo a perder posición, admiración o sustento material, y por eso oscila entre impotencia y prepotencia. El aprendizaje es confiar en tu potencia creadora, definir tu propia idea de éxito e integrar lo emocional con lo laboral.",
      keywords: ["poder", "abundancia", "seguridad", "potencia"]
    },
    9: {
      title: "Número 9",
      summary:
        "Tu karma aparece cuando te vuelves salvador del clan y buscas reconocimiento a través de todo lo que das por los demás.",
      longText:
        "Aquí hay una tendencia a proteger, cargar, rescatar y sostener a todos, mientras tu propio proyecto queda en segundo plano. La evolución consiste en servir sin depender del aplauso, separar amor de sacrificio y construir una vida con mayor autonomía espiritual y emocional.",
      keywords: ["servicio", "reconocimiento", "desapego", "autonomía"]
    },
    11: {
      title: "Número 11",
      summary:
        "La lección es salir de la sobreexigencia, la culpa y la necesidad de acreditar tu valor para construir dignidad y fe en tu camino.",
      longText:
        "Esta vibración carga con expectativas de excelencia y con la presión de elevar al clan por encima de su historia. El reto es dejar de vivir para responder al ideal familiar, confiar en tu visión y usar tu sensibilidad y conciencia sin sacrificar tu propia vida.",
      keywords: ["dignidad", "fe", "excelencia", "autenticidad"]
    }
  },
  B: {
    1: {
      title: "Número 1",
      summary:
        "Tu nuevo YO viene a liderar, abrir camino y atreverse a ser diferente, incluso si eso te obliga a caminar solo.",
      longText:
        "Esta esencia te pide confrontar el modelo tradicional del clan y construir una identidad propia, libre y pionera. Tu conquista está en dejar el molde del hijo ejemplar, confiar en tu criterio y liderar sin esconder emociones detrás de una máscara de dureza.",
      keywords: ["individualidad", "valentía", "liderazgo", "autonomía"]
    },
    2: {
      title: "Número 2",
      summary:
        "Vienes a construir vínculos sanos, alianzas reales y confianza, dejando atrás la manipulación, la duda y el miedo a la exclusión.",
      longText:
        "Tu evolución pasa por habitar tu sensibilidad con dignidad y aprender a cooperar sin perderte en la necesidad de agradar. Cuando desarrollas esta vibración, te conviertes en puente, respaldo y armonizador de relaciones más maduras y solidarias.",
      keywords: ["armonía", "alianza", "confianza", "sensibilidad"]
    },
    3: {
      title: "Número 3",
      summary:
        "Tu esencia crece cuando te escuchas, eliges tu propio escenario y usas tu creatividad para ser tú, no para complacer.",
      longText:
        "Este número te invita a recuperar a tu niño interior, darle voz a tus talentos y dejar de girar alrededor de la aprobación del grupo. Tu nueva identidad brilla cuando te expresas con alegría, enfoque y congruencia con lo que realmente deseas.",
      keywords: ["expresión", "creatividad", "autenticidad", "alegría"]
    },
    4: {
      title: "Número 4",
      summary:
        "Vienes a derrumbar estructuras obsoletas y a mostrar que la estabilidad también puede incluir placer, descanso y afecto.",
      longText:
        "Tu nuevo YO no está llamado a repetir un sistema rígido de trabajo, control y escasez, sino a construir un orden más sano. El aprendizaje está en organizar, manifestar y sostener, pero sin convertir la disciplina en prisión ni el rendimiento en única medida de valor.",
      keywords: ["orden", "manifestación", "equilibrio", "bienestar"]
    },
    5: {
      title: "Número 5",
      summary:
        "Tu esencia viene a romper cadenas, ampliar la mirada del clan y aprender a vivir con libertad sin perder centro.",
      longText:
        "Este número trae visión progresista, valentía para desafiar lo establecido y un magnetismo que abre puertas. Su reto no es escapar por impulso, sino usar el cambio para construir una vida más auténtica, flexible y expansiva.",
      keywords: ["libertad", "progreso", "cambio", "adaptabilidad"]
    },
    6: {
      title: "Número 6",
      summary:
        "Tu nuevo YO florece cuando conviertes el cuidado en amor maduro y dejas de medir tu valor por todo lo que das.",
      longText:
        "Esta vibración te llama a construir familia, armonía y contención desde el amor propio, no desde el sacrificio. Tu gran conquista está en nutrir sin salvar, amar sin desbordarte y ponerte en el primer lugar de tu lista de prioridades.",
      keywords: ["amor propio", "familia", "nutrición", "madurez emocional"]
    },
    7: {
      title: "Número 7",
      summary:
        "Tu esencia viene a romper leyes internas ajenas y a perseguir tu propia verdad con rigor, fe y responsabilidad hacia ti.",
      longText:
        "Aquí el crecimiento pasa por soltar la culpa de no cumplir las expectativas del clan y usar tu mente profunda para construir una visión propia. Cuando esta energía madura, se convierte en sabiduría aplicada, ética interna y compromiso real con tu proyecto de vida.",
      keywords: ["verdad", "sabiduría", "fe", "responsabilidad"]
    },
    8: {
      title: "Número 8",
      summary:
        "Tu nuevo YO está llamado a crear éxito con propósito, alejándose del control y del modelo familiar basado solo en poder o prestigio.",
      longText:
        "Esta vibración pide que te pares con fuerza en el mundo material y confíes en tu talento para generar abundancia fuera del guion paterno o clanico. Su evolución más alta aparece cuando integras resultados, conciencia y bienestar colectivo.",
      keywords: ["éxito", "abundancia", "liderazgo", "propósito"]
    },
    9: {
      title: "Número 9",
      summary:
        "Tu esencia se expande cuando dejas de rescatar al clan y orientas tu entrega hacia una vida con propósito propio y servicio elevado.",
      longText:
        "Este número trae vocación humanista, ideales altos y deseo de defender causas justas. El reto está en cortar el cordón umbilical con la familia, dejar de sostener a todos y usar tu sensibilidad para construir una misión más libre, amplia y significativa.",
      keywords: ["propósito", "humanismo", "servicio", "autonomía"]
    },
    11: {
      title: "Número 11",
      summary:
        "Tu nuevo YO viene a elevar la conciencia del clan y del mundo, usando tu sabiduría sin seguir postergando tu misión.",
      longText:
        "Esta vibración maestra confronta arrogancia, prejuicio y estrechez mental para abrir una visión más luminosa y profunda. Tu conquista está en confiar en tu canal de entendimiento, compartir lo que sabes y construir una verdad propia más allá del juicio familiar.",
      keywords: ["conciencia", "maestría", "visión", "servicio"]
    },
    22: {
      title: "Número 22",
      summary:
        "Tu esencia trae poder constructor y la misión de materializar algo grande que beneficie a otros, no solo al sistema familiar.",
      longText:
        "Este número maestro te pide salir de la influencia de las historias de éxito o fracaso del clan y crear con ética, justicia y conciencia colectiva. Su evolución aparece cuando reemplazas la competencia por cooperación y usas tu capacidad de logro para abrir bienestar compartido.",
      keywords: ["materialización", "legado", "cooperación", "bien común"]
    }
  },
  C: {
    1: {
      title: "Número 1",
      summary:
        "Traes iniciativa, fuerza y capacidad de abrir camino, pero ya no necesitas demostrar todo el tiempo que puedes con todo.",
      longText:
        "Tu YO del pasado dejó como herencia proactividad, entusiasmo y empuje para liderar con rapidez. El ajuste en esta vida consiste en soltar la máscara de fortaleza absoluta, bajar la necesidad de protagonismo y dar espacio a la vulnerabilidad y a otros puntos de vista.",
      keywords: ["iniciativa", "autonomía", "liderazgo", "vulnerabilidad"]
    },
    2: {
      title: "Número 2",
      summary:
        "Traes diplomacia, empatía y capacidad de sostener vínculos, pero necesitas soltar la insatisfacción crónica y la duda.",
      longText:
        "Esta memoria te da talento para acompañar, negociar y ofrecer respaldo genuino a otros. El reto es dejar de vivir desde la desconfianza, el apego o la espera constante de algo más, para vincularte con mayor paz y menos dependencia emocional.",
      keywords: ["empatía", "diplomacia", "respaldo", "desapego"]
    },
    3: {
      title: "Número 3",
      summary:
        "Tu pasado te dio carisma, voz y magnetismo social, pero ya no necesitas vivir del aplauso ni sostener escenarios ajenos.",
      longText:
        "Aquí hay una facilidad natural para comunicar, negociar, vender, enseñar y contagiar entusiasmo. La evolución está en dejar la necesidad de ser especial o estar siempre disponible para todos, y usar tu brillo en un escenario verdaderamente propio.",
      keywords: ["carisma", "voz", "popularidad", "propósito"]
    },
    4: {
      title: "Número 4",
      summary:
        "Traes disciplina, orden y capacidad de manifestar resultados, pero necesitas abrir espacio al descanso y al afecto.",
      longText:
        "Esta energía ya domina la constancia, la organización y la construcción de modelos sólidos y medibles. El reto actual es dejar de esconderte en el trabajo o en la rutina para no arriesgarte, y permitirte una vida con mayor dulzura, disfrute y flexibilidad.",
      keywords: ["disciplina", "orden", "resultados", "descanso"]
    },
    5: {
      title: "Número 5",
      summary:
        "Traes magnetismo, flexibilidad y valentía para atravesar crisis, pero ya no necesitas escapar cada vez que algo te compromete.",
      longText:
        "Tu YO del pasado te dejó talento para adaptarte, negociar bajo presión y encontrar salidas donde otros se bloquean. La tarea pendiente es quedarte, echar raíz y compartir la sabiduría obtenida en vez de seguir moviéndote por miedo a perder libertad.",
      keywords: ["magnetismo", "flexibilidad", "movimiento", "compromiso"]
    },
    6: {
      title: "Número 6",
      summary:
        "Tu sabiduría está en cuidar, nutrir y contener, pero el crecimiento llega cuando dejas de hacerte cargo de todo el mundo.",
      longText:
        "Esta memoria te da una gran sensibilidad para proteger, acompañar y sostener emocionalmente a quienes amas. El aprendizaje actual consiste en dejar de rescatar, dejar de poner a otros en deuda contigo y usar tu amor para cuidarte también a ti.",
      keywords: ["cuidado", "familia", "contención", "autocuidado"]
    },
    7: {
      title: "Número 7",
      summary:
        "Traes mente analítica, autoridad moral y profundidad, pero ya no tienes que cargar la responsabilidad de todos.",
      longText:
        "Esta posición da capacidad para revisar, ordenar, especializar y ver lo que otros no notan. La evolución pide soltar la culpa por dejar de sostener los sueños ajenos y usar tu inteligencia rigurosa para priorizar tu propia obra y tus propios tiempos.",
      keywords: ["análisis", "profundidad", "autoridad", "prioridad personal"]
    },
    8: {
      title: "Número 8",
      summary:
        "Traes liderazgo, ambición y capacidad de generar prosperidad, pero necesitas resignificar el poder sin apego a la posición.",
      longText:
        "Tu YO del pasado supo dirigir, exigir y construir resultados de alto impacto con disciplina y competitividad. El ajuste de esta vida consiste en soltar el miedo a perder estatus o autoridad e integrar el mundo emocional y espiritual a tu noción de éxito.",
      keywords: ["poder", "prosperidad", "autoridad", "equilibrio"]
    },
    9: {
      title: "Número 9",
      summary:
        "Traes liderazgo social y vocación de servicio, pero ahora necesitas elegirte también a ti y cortar dependencias afectivas.",
      longText:
        "Esta memoria otorga capacidad de integrar grupos, luchar por causas justas y movilizar a otros hacia metas elevadas. La evolución llega cuando dejas de rescatar por costumbre, sueltas la figura del héroe y construyes una vida más autónoma frente al clan.",
      keywords: ["servicio", "liderazgo social", "causa", "autonomía"]
    },
    11: {
      title: "Número 11",
      summary:
        "Traes visión, sabiduría y capacidad de abrir conciencia, pero necesitas confiar en ti y dejar de aplazar tu misión.",
      longText:
        "Tu YO del pasado guarda profundidad mental, intuición y autoridad para enseñar o iluminar procesos complejos. La tarea actual es dejar el autosabotaje, soltar la idea de no estar listo y empezar a donar tu comprensión al mundo con más fe y menos postergación.",
      keywords: ["visión", "sabiduría", "intuición", "fe"]
    },
    22: {
      title: "Número 22",
      summary:
        "Traes poder de realización colectiva y capacidad de construir sistemas, pero debes usar ese poder con humildad y servicio.",
      longText:
        "Esta memoria habla de un talento extraordinario para crear modelos de éxito, abundancia y organización que beneficien a muchos. El aprendizaje consiste en no apegarte al mando o al control, sino en convertir el poder en una herramienta para servir con justicia y equilibrio.",
      keywords: ["sistema", "abundancia", "servicio", "humildad"]
    }
  },
  D: {
    1: {
      title: "Número 1",
      summary:
        "Tu máscara comunica independencia, empuje y diferencia, pero puede volverse una barrera que te aísla.",
      longText:
        "Sueles proyectarte como alguien autosuficiente, exigente y poco convencional, con fuerte magnetismo y necesidad de avanzar rápido. La clave está en no usar esa imagen para demostrar que no necesitas a nadie ni ocultar lo que sientes detrás del rendimiento.",
      keywords: ["independencia", "magnetismo", "exigencia", "distancia"]
    },
    2: {
      title: "Número 2",
      summary:
        "Tu imagen externa despierta empatía y cercanía, pero puede hacer que otros te vean frágil o necesitado de dirección.",
      longText:
        "Esta máscara se expresa a través de delicadeza, calidez, cooperación y una habilidad natural para acompañar a otros. Su sombra aparece cuando cedes demasiada iniciativa, te vuelves indeciso o terminas sosteniendo un personaje encantador que busca respaldo constante.",
      keywords: ["empatía", "armonía", "respaldo", "indecisión"]
    },
    3: {
      title: "Número 3",
      summary:
        "Tu máscara es magnética, divertida y expresiva, pero puede quedar atrapada en la validación y la disponibilidad total.",
      longText:
        "Tiendes a mostrar una energía sociable, entusiasta y muy visible que atrae con facilidad a los demás. El riesgo está en convertirte en el amigo, guía o animador de todos para sentirte amado, dejando para después tu compromiso contigo mismo.",
      keywords: ["magnetismo", "popularidad", "validación", "dispersión"]
    },
    4: {
      title: "Número 4",
      summary:
        "La imagen que proyectas es seria, confiable y resolutiva, aunque a veces puede sentirse rígida o controladora.",
      longText:
        "Los demás suelen verte como alguien estable, disciplinado y orientado a resultados, capaz de sostener procesos y dar seguridad. La sombra de esta máscara aparece cuando el orden se vuelve cerrazón, la exigencia domina el vínculo y el control reemplaza la espontaneidad.",
      keywords: ["seriedad", "estabilidad", "control", "rigidez"]
    },
    5: {
      title: "Número 5",
      summary:
        "Tu máscara proyecta libertad, carisma y desafío, pero puede terminar pareciendo escapista, inconstante o impulsiva.",
      longText:
        "Hay una energía seductora, progresista y poco convencional que atrae por su espontaneidad y su deseo de movimiento. El desafío consiste en no usar esa libertad como excusa para huir del compromiso, desaparecer de escena o vivir sin estructura suficiente.",
      keywords: ["libertad", "carisma", "rebeldía", "escape"]
    },
    6: {
      title: "Número 6",
      summary:
        "Tu imagen habla de cuidado, familia y protección, aunque también puede volverse demandante, territorial o dramática.",
      longText:
        "Sueles ser percibido como alguien cálido, contenedor y profundamente atento al bienestar de su grupo. La sombra aparece cuando esa necesidad de sostener a todos se convierte en control afectivo, sobreprotección o dramatización por miedo al abandono.",
      keywords: ["protección", "familia", "demanda", "territorio"]
    },
    7: {
      title: "Número 7",
      summary:
        "Tu máscara proyecta excelencia, clase y profundidad, pero también puede sentirse severa, cerrada o prejuiciosa.",
      longText:
        "Los demás suelen verte como alguien responsable, observador, formal y algo misterioso, con fuerte autoridad intelectual. El trabajo está en no usar esa imagen para volverte inaccesible, excesivamente crítico o superior frente a quienes no responden a tus estándares.",
      keywords: ["excelencia", "misterio", "autoridad", "severidad"]
    },
    8: {
      title: "Número 8",
      summary:
        "La imagen que proyectas es de éxito, fuerza y autoridad, pero puede endurecerte si todo gira alrededor del control y el logro.",
      longText:
        "Se te percibe como líder, referente de resultados y figura de poder con presencia fuerte y competitiva. Su sombra aparece cuando la ambición desplaza tu vida emocional, el prestigio se vuelve obsesión y el mando se expresa como rigidez o autoritarismo.",
      keywords: ["éxito", "autoridad", "ambición", "control"]
    },
    9: {
      title: "Número 9",
      summary:
        "Tu máscara te muestra como héroe, protector y figura de causa, aunque puede dejarte atrapado en el sacrificio y el aplauso.",
      longText:
        "Los demás ven en ti generosidad, compromiso colectivo y sensibilidad para cuidar a quien lo necesita. El riesgo está en dirigir demasiado la vida ajena, vivir del reconocimiento por rescatar y quedarte anclado a un ideal que te aleje de tu realidad presente.",
      keywords: ["heroísmo", "servicio", "idealismo", "reconocimiento"]
    },
    11: {
      title: "Número 11",
      summary:
        "Tu imagen externa inspira, enseña y eleva, pero puede cargarte con la idea de que debes resolver la evolución de todos.",
      longText:
        "Esta máscara se percibe sabia, profunda, resiliente y con un aura de maestría que abre conciencia en los demás. La clave está en poner límites sanos para no convertirte en el responsable absoluto de iluminar a todos mientras postergas tu propio proyecto.",
      keywords: ["inspiración", "maestría", "límites", "misión"]
    },
    22: {
      title: "Número 22",
      summary:
        "Tu máscara proyecta triunfo, capacidad de mando y protección, pero puede llevarte a sostener a todos antes que a ti.",
      longText:
        "Los demás te perciben como una figura grande, generosa y altamente capaz de construir prosperidad y dirección para el grupo. El aprendizaje consiste en no quedarte solo en el rol del gran proveedor o impulsor del éxito ajeno, y reservar energía para tu propia realización.",
      keywords: ["triunfo", "mando", "protección", "realización propia"]
    }
  }
};

const VARIANT_TEMPLATES = {
  A: [
    ({ keywords }) =>
      `Tu historia te pide revisar cómo ${keywords[0]} y ${keywords[1]} siguen marcando decisiones que hoy ya podrías tomar de otra manera.`,
    ({ keywords }) =>
      `Esta faceta se activa cuando la vieja lealtad al clan pesa más que tu libertad para elegir desde ${keywords[0]} y ${keywords[2]}.`,
    ({ keywords }) =>
      `Cuando este punto domina, suele aparecer la tentación de repetir el patrón familiar en temas de ${keywords[1]} y ${keywords[3]}.`
  ],
  B: [
    () =>
      "Aquí aparece la identidad que vienes a construir con intención propia, incluso si eso te obliga a salir del molde conocido.",
    () =>
      "Tu nuevo YO se fortalece cada vez que eliges desde el deseo auténtico y no desde la expectativa familiar.",
    () =>
      "Esta posición muestra cómo te individualizas: lo que debes desarrollar para ser más tú y menos personaje."
  ],
  C: [
    () =>
      "Esta memoria ya te dio oficio interno: bien usada, se vuelve talento; mal usada, te devuelve a la zona segura.",
    () =>
      "Tu YO del pasado trae recursos reales, pero también la tentación de seguir viviendo desde lo que ya conoces.",
    () =>
      "Aquí vive una sabiduría útil, siempre que no la uses como excusa para evitar el compromiso con tu presente."
  ],
  D: [
    () =>
      "Tu máscara puede abrir puertas rápido, pero también puede tapar emociones o necesidades que no siempre muestras.",
    () =>
      "La imagen externa funciona como carta de presentación; la clave es usarla a tu favor sin quedarte atrapado en ella.",
    () =>
      "Cuando esta faceta se endurece, los demás ven sobre todo el personaje y cada vez menos a la persona que hay detrás."
  ]
};

function stableHash(value = "") {
  return Array.from(String(value)).reduce((acc, char) => {
    return (acc * 31 + char.charCodeAt(0)) >>> 0;
  }, 0);
}

function normalizePosition(position) {
  return String(position || "").trim().toUpperCase();
}

function createFallbackMeaning(position, number) {
  const meta = HORIZONTAL_POSITION_META[position];
  return {
    title: `Número ${number}`,
    summary: `Aún no hay una redacción editorial específica para esta combinación dentro de ${meta?.label || "la Horizontal Numerológica"}.`,
    longText:
      "Puedes usar este valor como una referencia simbólica del eje personal mientras se amplía la biblioteca de interpretaciones.",
    keywords: ["identidad", "observación", "proceso", "lectura"]
  };
}

export function getHorizontalMeaning(position, number) {
  const normalizedPosition = normalizePosition(position);
  const numericKey = Number(number);
  const entry = HORIZONTAL_NUMEROLOGICA[normalizedPosition]?.[numericKey];
  return entry || createFallbackMeaning(normalizedPosition, numericKey);
}

export function buildHorizontalSeed({
  profileId,
  ninjaProfileId,
  birthDate,
  profileName
} = {}) {
  return [
    profileId || "",
    ninjaProfileId || "",
    birthDate || "",
    profileName || ""
  ]
    .filter(Boolean)
    .join("|");
}

export function getHorizontalVariant({ position, number, seedKey }) {
  const normalizedPosition = normalizePosition(position);
  const meaning = getHorizontalMeaning(normalizedPosition, number);
  const templates = VARIANT_TEMPLATES[normalizedPosition] || [];

  if (!templates.length) {
    return {
      ...meaning,
      emphasis: meaning.summary,
      emphasisIndex: 0
    };
  }

  const hash = stableHash(`${seedKey || "default"}:${normalizedPosition}:${number}`);
  const emphasisIndex = hash % templates.length;
  const emphasis = templates[emphasisIndex](meaning);

  return {
    ...meaning,
    emphasis,
    emphasisIndex
  };
}
